import WaghTutorial from "../ClientHomePages/WaghTutorial";

export const ClientMappings = {
    '514a665cc3': {
        name: 'WaghTutorial',
        file: WaghTutorial,
    },
};